import { defineComponent as _defineComponent } from 'vue'
import { ISignupField } from "@/domain/entities/serviceInfo/serviceInfo.types";
import { PropType, computed } from "vue";
import TextInput from "@/components/shared/inputs/TextInput.vue";
import PasswordInput from "@/components/shared/inputs/PasswordInput.vue";
import CheckboxInput from "../shared/inputs/CheckboxInput.vue";
import EmailInput from "../shared/inputs/EmailInput.vue";
import PhoneInput from "../shared/inputs/PhoneInput.vue";
import AddressInput from "../shared/inputs/AddressInput.vue";
import EmailCertInput from "../shared/inputs/EmailCertInput.vue";
import PasswordConfirmInput from "../shared/inputs/PasswordConfirmInput.vue";
import PhoneCertInput from "../shared/inputs/PhoneCertInput.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { IOption, TimerStatus } from "@/types";
import DynamicSelect from "../shared/inputs/DynamicSelect.vue";
import LoginIdInput from "@/components/shared/inputs/LoginIdInput.vue";
import CompanyInput from "./CompanyInput.vue";


const __default__ = {
  name: "DynamicFormField",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  field: {
    type: Object as PropType<ISignupField>,
    required: true,
  },
  value: {
    type: null as any,
  },
  parentValue: {
    type: null as any,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rankCode: {
    type: String,
  },
  required: {
    type: Boolean,
  },
  authRequiredForEditYn: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Object,
  },
},
  emits: ["update:value", "onUpdatedOptions", "updateChildFieldOptions", "updateChildTimerStatus"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const serviceStore = useServiceStore();

const emit = __emit;

const props = __props;

const inputValue = computed({
  get(): any {
    return props.value;
  },
  set(inputValue: any) {
    if (props.value === inputValue) return;
    emit("update:value", inputValue);

    if (props.field.type !== "option") return;

    if (props.field.isDirectlyEditable) {
      updateChildFieldValidity(true);
      return;
    }

    updateChildFieldValidity(!!inputValue);
  },
});

const getComponent = (field: ISignupField) => {
  if (field.key === "JOIN.LOGINID") {
    return LoginIdInput;
  } else if (field.key === "JOIN.DUTY_MANAGER_PHONE") {
    return PhoneInput;
  } else if (field.key === "JOIN.BP_NAME") {
    return CompanyInput;
  }

  return componentMap[field.type ?? ""];
};

const componentMap: Record<string, any> = {
  textbox: TextInput,
  password: PasswordInput,
  passwordCert: PasswordConfirmInput,
  checkbox: CheckboxInput,
  email: EmailInput,
  emailCertNo: EmailCertInput,
  phone: PhoneInput,
  phoneCertNo: PhoneCertInput,
  address: AddressInput,
  option: DynamicSelect,
};

const updateChildFieldValidity = (isValid: boolean) => {
  const childField = serviceStore.getChildField(
    props.rankCode ?? "",
    props.field.key ?? ""
  );

  if (!childField) return;

  serviceStore.updateFieldValidity(
    props.rankCode ?? "",
    childField?.key ?? "",
    isValid
  );
};

const updateOptions = (options: IOption[]) => {
  serviceStore.updateFieldOptions(
    props.rankCode ?? "",
    props.field.key ?? "",
    options
  );
  emit("updateChildFieldOptions", inputValue.value);
};

const updateTimerStatus = (timerStatus: TimerStatus) => {
  serviceStore.updateFieldTimerStatus(
    props.rankCode ?? "",
    props.field?.key ?? "",
    timerStatus
  );
};

const updateAllParentFieldValidity = (isValid: boolean) => {
  // field부터 최상위에 있는 부모 field까지 isValid 데이터 갱신
  let field: ISignupField | undefined = props.field;
  while (field) {
    serviceStore.updateFieldValidity(
      props.rankCode ?? "",
      field.key ?? "",
      isValid
    );
    field = serviceStore.getParentField(
      props.rankCode ?? "",
      field.parentFieldKey ?? ""
    );
  }

  serviceStore.updateVerificationSuccess(
    props.rankCode ?? "",
    props.field.key ?? "",
    true
  );
};

const updateVerficationCodeSent = (isSent: boolean) => {
  serviceStore.updateVerficationCodeSent(
    props.rankCode ?? "",
    props.field.key ?? "",
    isSent
  );
};

const __returned__ = { serviceStore, emit, props, inputValue, getComponent, componentMap, updateChildFieldValidity, updateOptions, updateTimerStatus, updateAllParentFieldValidity, updateVerficationCodeSent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})